/**
 * Buggino v3 – Dialoge (Gewährleistung, Klarna), Topbar-Rotation, PDP-Updates bei Variantenwechsel
 * (Klarna-Rate, Punkte, Ersparnis, Sticky-ATC), Warenkorb-Punkte, PDP-Navigation, Mobil-Galerie,
 * Widerrufsformular-Beleg.
 */
(function () {
  'use strict';

  const root = document.documentElement;
  const moneyFormat = root.dataset.moneyFormat || '{{amount_with_comma_separator}} €';
  const money = (cents) =>
    window.Buggino && window.Buggino.formatMoney
      ? window.Buggino.formatMoney(cents, moneyFormat)
      : (Number(cents) / 100).toFixed(2).replace('.', ',') + ' €';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Dialoge ---------- */
  function initDialogs() {
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-open-dialog]');
      if (opener) {
        const dialog = document.getElementById(opener.dataset.openDialog);
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          if (window.Buggino && window.Buggino.openDialog) window.Buggino.openDialog(dialog, opener);
          else dialog.showModal();
        }
        return;
      }
      const closer = event.target.closest('[data-close-dialog]');
      if (closer) {
        const dialog = closer.closest('dialog');
        if (dialog) dialog.close();
        return;
      }
      if (event.target.matches('dialog.dialog--notice, dialog#klarna-info')) {
        const rect = event.target.getBoundingClientRect();
        const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) event.target.close();
      }
    });
    // Gewährleistungs-Mitteilung beim Hover/Fokus vorladen, damit sie beim ersten Klick sofort steht
    const notice = document.querySelector('#legal-guarantee img');
    if (notice) {
      const warm = () => {
        notice.loading = 'eager';
      };
      document.querySelectorAll('[data-open-dialog="legal-guarantee"]').forEach((el) => {
        el.addEventListener('pointerenter', warm, { once: true });
        el.addEventListener('focus', warm, { once: true });
      });
    }
  }

  /* ---------- Topbar: auf schmalen Bildschirmen rotierend ---------- */
  function initTopbar() {
    const list = document.querySelector('[data-topbar]');
    if (!list || reduceMotion) return;
    const items = Array.from(list.children);
    if (items.length < 2) return;
    let index = 0;
    const mq = window.matchMedia('(max-width: 1023px)');
    let timer = null;
    const tick = () => {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    };
    const sync = () => {
      window.clearInterval(timer);
      timer = null;
      if (mq.matches) timer = window.setInterval(tick, 3800);
    };
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
    sync();
  }

  /* ---------- Footer: Cookie-Einstellungen erneut öffnen (Shopify-Cookie-Banner, nur wo er geladen ist) ---------- */
  function initCookiePrefs() {
    const btn = document.querySelector('[data-cookie-prefs]');
    if (!btn) return;
    const ready = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    const reveal = () => {
      if (ready()) btn.hidden = false;
    };
    reveal();
    window.setTimeout(reveal, 2500);
    document.addEventListener('visitorConsentCollected', reveal);
    btn.addEventListener('click', () => {
      if (ready()) window.privacyBanner.showPreferences();
    });
  }

  /* ---------- Hero-Video (Desktop): ruhige Endlosschleife, pausiert außerhalb des Sichtbereichs ---------- */
  function initHeroVideo() {
    const video = document.querySelector('[data-hero-video]');
    if (!video || reduceMotion) return;
    const mq = window.matchMedia('(min-width: 900px)');
    if (!mq.matches) return;
    const conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    const start = () => {
      [['srcMp4', 'video/mp4'], ['srcWebm', 'video/webm']].forEach(([key, type]) => {
        if (!video.dataset[key]) return;
        const source = document.createElement('source');
        source.src = video.dataset[key];
        source.type = type;
        video.appendChild(source);
      });
      video.load();
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) { const q = video.play(); if (q && q.catch) q.catch(() => {}); }
            else video.pause();
          });
        }).observe(video);
      }
    };
    if (document.readyState === 'complete') window.setTimeout(start, 600);
    else window.addEventListener('load', () => window.setTimeout(start, 600), { once: true });
  }

  /* ---------- PDP: Variantenwechsel ---------- */
  function initVariantExtras() {
    const box = document.querySelector('[data-product-root]');
    if (!box) return;
    const klarnaRate = box.querySelector('[data-klarna-rate]');
    const klarnaLine = box.querySelector('[data-klarna-line]');
    const points = box.querySelector('[data-points-line]');
    const stickyLabel = document.querySelector('[data-sticky-label]');
    const i18nAdd = (box.querySelector('[data-i18n-add]') || {}).textContent || '';
    const i18nSold = (box.querySelector('[data-i18n-sold-out]') || {}).textContent || '';

    document.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      if (klarnaRate) klarnaRate.textContent = money(Math.floor((variant.price + 2) / 3));
      if (klarnaLine) klarnaLine.hidden = variant.price < 3500;
      if (points) {
        const pts = Math.floor(variant.price / 100);
        const strongs = points.querySelectorAll('strong');
        if (strongs[0]) strongs[0].textContent = String(pts);
        if (strongs[1]) strongs[1].textContent = money(pts * 2);
      }
      if (stickyLabel) stickyLabel.textContent = variant.available ? i18nAdd : i18nSold;
      const badge = box.querySelector('[data-save-badge]');
      if (badge) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        badge.hidden = !onSale;
        if (onSale) badge.textContent = `−${Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)} %`;
      }
    });
  }

  /* ---------- Warenkorb-Drawer: Punkte & Klarna ---------- */
  function initCartPerks() {
    document.addEventListener('cart:rendered', (event) => {
      const cart = event.detail;
      if (!cart) return;
      const pts = Math.floor(cart.total_price / 100);
      const pointsEl = document.querySelector('[data-cart-points]');
      if (pointsEl) {
        const text = pointsEl.querySelector('[data-cart-points-text]');
        pointsEl.hidden = pts === 0;
        if (text && pointsEl.dataset.template) {
          text.innerHTML = pointsEl.dataset.template.replace('[points]', String(pts)).replace('[worth]', money(pts * 2));
        }
      }
      const klarna = document.querySelector('[data-cart-klarna]');
      if (klarna) {
        klarna.hidden = cart.total_price < 3500;
        const text = klarna.querySelector('[data-cart-klarna-text]');
        if (text && klarna.dataset.template) {
          text.innerHTML = klarna.dataset.template.replace('[rate]', money(Math.floor((cart.total_price + 2) / 3)));
        }
      }
    });
  }

  /* ---------- PDP-Navigation (aktiver Abschnitt) ---------- */
  function initPdpNav() {
    const nav = document.querySelector('[data-pdp-nav]');
    if (!nav || !('IntersectionObserver' in window)) return;
    const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
    const targets = links.map((a) => document.querySelector(a.getAttribute('href'))).filter(Boolean);
    const setActive = (id) => {
      links.forEach((a) => {
        const on = a.getAttribute('href') === `#${id}`;
        a.classList.toggle('is-active', on);
        if (on && nav.scrollWidth > nav.clientWidth) {
          a.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
    };
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );
    targets.forEach((t) => io.observe(t));
  }

  /* ---------- Mobil-Galerie: Wischen + Punkte ---------- */
  function initMobileGallery() {
    const gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    const main = gallery.querySelector('.gallery__main');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    if (!main || slides.length < 2) return;
    const dots = document.createElement('div');
    dots.className = 'gallery__dots';
    dots.setAttribute('aria-hidden', 'true');
    slides.forEach((_, i) => {
      const dot = document.createElement('span');
      if (i === 0) dot.classList.add('is-active');
      dots.appendChild(dot);
    });
    const counter = document.createElement('span');
    counter.className = 'gallery__counter';
    counter.setAttribute('aria-hidden', 'true');
    counter.textContent = `1 / ${slides.length}`;
    main.after(dots);
    main.appendChild(counter);
    const mq = window.matchMedia('(max-width: 899px)');
    let ticking = false;
    main.addEventListener(
      'scroll',
      () => {
        if (!mq.matches || ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          const i = Math.round(main.scrollLeft / main.clientWidth);
          Array.from(dots.children).forEach((d, n) => d.classList.toggle('is-active', n === i));
          counter.textContent = `${i + 1} / ${slides.length}`;
        });
      },
      { passive: true }
    );
    document.addEventListener('variant:change', (event) => {
      if (!mq.matches) return;
      const id = event.detail && event.detail.mediaId;
      if (!id) return;
      const index = slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (index >= 0) main.scrollTo({ left: index * main.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  /* ---------- Widerruf: Beleg mit Zeitstempel ---------- */
  function initWithdraw() {
    const form = document.querySelector('[data-withdraw-form]');
    const KEY = 'bg_withdraw';
    if (!form) return;
    const done = form.querySelector('[data-withdraw-done]');
    const i18n = document.querySelector('[data-withdraw-i18n]');
    if (!done) {
      form.addEventListener('submit', () => {
        const data = {};
        form.querySelectorAll('[data-w]').forEach((el) => {
          if (el.value) data[el.dataset.w] = el.value;
        });
        data.time = new Date().toISOString();
        try {
          sessionStorage.setItem(KEY, JSON.stringify(data));
        } catch (e) {}
      });
      return;
    }
    let data = null;
    try {
      data = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    } catch (e) {}
    const receipt = done.querySelector('[data-withdraw-receipt]');
    if (data && receipt && i18n) {
      const lang = root.lang || 'de';
      const time = new Intl.DateTimeFormat(lang, { dateStyle: 'full', timeStyle: 'medium' }).format(new Date(data.time));
      const rows = [['time', time], ['name', data.name], ['email', data.email], ['order', data.order], ['date', data.date], ['items', data.items], ['note', data.note]];
      rows.forEach(([k, v]) => {
        if (!v) return;
        const dt = document.createElement('dt');
        dt.textContent = i18n.dataset[k] || k;
        const dd = document.createElement('dd');
        dd.textContent = v;
        receipt.append(dt, dd);
      });
      receipt.hidden = false;
    }
    const print = done.querySelector('[data-withdraw-print]');
    if (print) print.addEventListener('click', () => window.print());
  }

  /* ---------- Mobil: schwebende App-Buttons erst nach dem ersten Scrollen ---------- */
  function initFloatUi() {
    const show = () => {
      if (window.scrollY > 240) {
        root.classList.add('float-ui-on');
        window.removeEventListener('scroll', show);
      }
    };
    window.addEventListener('scroll', show, { passive: true });
    show();
  }

  function init() {
    initFloatUi();
    initCookiePrefs();
    initHeroVideo();
    initDialogs();
    initTopbar();
    initVariantExtras();
    initCartPerks();
    initPdpNav();
    initMobileGallery();
    initWithdraw();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
